//Margin Comopnent for Calendar Chart
import React from 'react';
import SliderWithInput from '../../SliderWithInput';

interface CalendarMarginsProps {
  calendarHeight: number;
  calendarGap: number;
  right: number;
  left: number;
  onMarginChange: (option: string, value: number) => void;
  onCalendarStyleChange: (option: string, value: number) => void;
  iconColor?: string;
}

const CalendarMargins: React.FC<CalendarMarginsProps> = ({
  calendarHeight,
  calendarGap,
  right,
  left,
  onMarginChange,
  onCalendarStyleChange,
  iconColor,
}) => {
  return (
    <>
      <div
        className="optionDescription"
        style={{
          marginTop: '10px',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        MARGIN RESIZE
      </div>
      <div
        className="optionDescription"
        style={{
          marginTop: '0px',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        Calender Height
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={calendarHeight}
        sliderMinMax={{ min: 10, max: 80, step: 1 }}
        changeValue={(value) => onCalendarStyleChange('calendarHeight', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Right
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={right}
        sliderMinMax={{ min: 0, max: 100, step: 1 }}
        changeValue={(value) => onMarginChange('right', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Left
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={left}
        sliderMinMax={{ min: 0, max: 100, step: 1 }}
        changeValue={(value) => onMarginChange('left', value)}
      />
      <div style={{ marginBottom: '15px' }}>
        <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
          Calendar gap
        </div>
        <SliderWithInput
          percent={true}
          sliderValue={calendarGap}
          sliderMinMax={{ min: 10, max: 80, step: 1 }}
          changeValue={(value) => onCalendarStyleChange('calendarGap', value)}
        />
      </div>
    </>
  );
};

export default CalendarMargins;
